import heatPump from './heat-pump.json';
import natureReal from './nature-real.json';
import training from './training.json';
import diyHome from './diy-home.json';

// Ordered by B2B priority:
// 🥇 Equipment Support (heat-pump) - Equipment Manufacturers/Maintenance
// 🥇 Visitor Experience (nature-real) - Tourism/Parks
// 🥈 Field Training (training) - Workforce Training
// 🥈 Home & Garden (diy-home) - Garden Centers
export const usecases = [
  heatPump,        // 🥇 Equipment Support (heat pump troubleshooting)
  natureReal,      // 🥇 Visitor Experience
  training,        // 🥈 Field Training
  diyHome,         // 🥈 Home Projects
];

export const usecaseMap = {
  'heat-pump': heatPump,
  'nature-real': natureReal,
  'training': training,
  'diy-home': diyHome,
};

export default usecases;
